<template>
    <LayoutSub>
        <SubSection class="pb-0" v-if="data">
            <div class="post_header">
                <h2>
                    {{ data.subject }}
                </h2>
                <span class="date">{{ new Date(data.writeDate).toLocaleDateString('ko-KR') }}</span>
            </div>

            <div class="board_content">
                <div class="board_content_body" v-html="data.contents"></div>
                <div class="attach_box" v-if="data.filename">
                    <div class="title_area">
                        <img src="@/assets/ic-attach.png" alt="" />
                        <span>첨부파일</span>
                    </div>
                    <div class="file_area">
                        <a :href="`${data.filePath}`" :download="data.orgFilename">{{ data.orgFilename }}</a>
                    </div>
                </div>
            </div>

            <div class="list_control_wrap">
                <div class="col" v-if="data.prevIdx">
                    <i class="ic_prev"></i>
                    <router-link :to="{
                        path: `./${data.prevIdx}`,
                        query: this.$route.query,
                    }">{{ data.prevSubject.slice(0, 24) }}{{ data.prevSubject.length > 24 ? '...' : ''
                        }}</router-link>
                </div>
                <div class="col none_inter" v-else>
                    <i class="ic_prev"></i>
                    <span>이전글이 없습니다.</span>
                </div>
                <div class="col list_button" @click="returnList">
                    <button>
                        <img src="@/assets/ic-list.png" alt="" />
                    </button>
                </div>
                <div class="col" v-if="data.nextIdx">
                    <router-link :to="{
                        path: `./${data.nextIdx}`,
                        query: this.$route.query,
                    }">{{ data.nextSubject.slice(0, 24) }}{{ data.nextSubject.length > 24 ? '...' : ''
                        }}</router-link>
                    <i class="ic_next"></i>
                </div>
                <div class="col none_inter" v-else>
                    <span>다음글이 없습니다.</span>
                    <i class="ic_next"></i>
                </div>
            </div>
        </SubSection>
        <LoadingWrap v-else />
    </LayoutSub>
</template>
<script>
import LoadingWrap from '@/components/LoadingWrap.vue';
import SubSection from '@/components/SubSection.vue';
import LayoutSub from '@/layouts/LayoutSub.vue';

export default {
    components: {
        LayoutSub,
        LoadingWrap,
        SubSection,
    },
    props: {
        data: {},
    },
    methods: {
        returnList() {
            const targetRoute = this.$route.path.split('/').slice(0, -1).join('/');
            this.$router.push({
                path: targetRoute,
                query: {
                    ...this.$route.query,
                },
            });
            return;
        },
    },
};
</script>
